import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="copyright">
        <small>&copy; Vignesh Chandrasekhar. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
